import Vue from 'vue';

import { extend } from 'vee-validate';

import {
    regex,
  } from 'vee-validate/dist/rules';

Vue.mixin({
    data() {
        return {
            passwordRules: extend('passwordRules', {
                ...regex,
                message: 'Mật khẩu phải từ 8-20 ký tự, gồm chữ thường, chữ in hoa, số và ký tự đặc biệt; không chứa "vuihoc".',
            }),
        };
    },
})
